import { render } from "./SocialModal.vue?vue&type=template&id=04ef2d32"
import script from "./SocialModal.vue?vue&type=script&lang=js"
export * from "./SocialModal.vue?vue&type=script&lang=js"

import "./SocialModal.vue?vue&type=style&index=0&id=04ef2d32&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__